export interface ScanEntry {
  trackingId: string;
  slot: string | null;
  status: 'stored' | 'retrieved' | 'not_found' | 'picked';
  type: 'inbound' | 'outbound';
  timestamp: number;
}

const STORAGE_KEY = 'warehouse_scan_history';

export function getScanHistory(): ScanEntry[] {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function addScanToHistory(entry: Omit<ScanEntry, 'timestamp'>) {
  const history = getScanHistory();
  history.unshift({ ...entry, timestamp: Date.now() });
  // Keep last 100
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, 100)));
}
